import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

interface DeleteWebhookIntegrationParams {
  webhookEndpointId: string;
}

export function useDeleteWebhookIntegration() {
  const { integrationService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, DeleteWebhookIntegrationParams>({
    mutationFn: ({ webhookEndpointId }) => {
      return integrationService
        .deleteWebhookIntegration(webhookEndpointId)
        .then(() => {
          return queryClient.invalidateQueries({
            queryKey: ["foxgloveIntegration"],
          });
        });
    },
  });
}
